module.exports = __webpack_public_path__ + "static/media/InnerBox_Sync.e2817164.svg";